<template>
  <td class="shipmentPallet" style="vertical-align: top; text-align: left;">
    {{ number }}
    <br/>
    <div v-if="!half">
      <v-tooltip top open-delay="500">
        <template v-slot:activator="{ on }">
          <div v-if="hasPallet" :class="palletClass(pallet)" @click="selectPallet(pallet)" v-on="on">
            Pallet #{{ pallet.palletNumber }}
            <span style="float: right; color: #707070;">{{ stateLabel(pallet.state) }}</span>
            <v-divider style="padding-bottom: 5px;"/>
            <PalletItems v-if="pallet.items" :items="pallet.items"/>
          </div>
          <div v-if="!hasPallet" :class="palletPositionClass()" @click="selectPalletPosition()">
          </div>
        </template>
        <span><div v-html="palletTitle(pallet)"></div></span>
      </v-tooltip>
    </div>
    <div v-if="half">
      <v-tooltip top open-delay="500">
        <template v-slot:activator="{ on }">
          <div v-if="hasPallet" :class="palletClass(pallet)" @click="selectPallet(pallet)" v-on="on">
            Pallet #{{ pallet.palletNumber }}
            <span style="float: right; color: #707070;">{{ stateLabel(pallet.state) }}</span>
            <v-divider style="padding-bottom: 5px;"/>
            <PalletItems v-if="pallet.items" :items="pallet.items"/>
          </div>
          <div v-if="!hasPallet" :class="palletPositionClass()" @click="selectPalletPosition()">
          </div>
        </template>
        <span><div v-html="palletTitle(pallet)"></div></span>
      </v-tooltip>
      <v-tooltip top open-delay="500">
        <template v-slot:activator="{ on }">
          <div style="margin-top: 5px;" v-if="hasPalletSecondRow" :class="palletClass(palletSecondRow)" @click="selectPallet(palletSecondRow)" v-on="on">
            Pallet #{{ palletSecondRow.palletNumber }}
            <span style="float: right; color: #707070;">{{ stateLabel(palletSecondRow.state) }}</span>
            <v-divider style="padding-bottom: 5px;"/>
            <PalletItems v-if="palletSecondRow.items" :items="palletSecondRow.items"/>
          </div>
          <div style="margin-top: 5px;" v-if="!hasPalletSecondRow" :class="palletPositionClassSecondRow()" @click="selectPalletPositionSecondRow()">
          </div>
        </template>
        <span><div v-html="palletTitle(palletSecondRow)"></div></span>
      </v-tooltip>
    </div>
  </td>
</template>

<script>
import PalletItems from '../components/PalletItems'

export default {
  name: 'ShipmentPallet',
  components: { PalletItems },
  props: {
    value: Object,
    number: String,
    palletPositions: Array,
    palletSelected: Object,
    palletPositionSelected: {},
    half: Boolean
  },
  created: function () {
  },
  data () {
    return {
    }
  },
  methods: {
    stateLabel: function (state) {
      switch (state) {
        case 'PLANNED': return 'Planned'
        case 'IN_PRODUCTION': return 'In production'
        case 'PRODUCED': return 'Produced'
        case 'READY_FOR_PICKUP': return 'Ready for pickup'
        case 'IN_TRANSPORT': return 'In transport'
        case 'REPACKED': return 'Repacked'
        case 'DELIVERED': return 'Delivered'
      }
      return 'Unknown'
    },
    isClickable: function (pallet) {
      return true
    },
    isSelected: function (pallet) {
      return this.palletSelected && this.palletSelected.id === pallet.id
    },
    isPositionSelected: function () {
      return this.palletPositionSelected && this.palletPositionSelected === this.number
    },
    isPositionSelectedSecondRow: function () {
      return this.palletPositionSelected && this.palletPositionSelected === Number(this.number) + 10
    },
    palletClass: function (pallet) {
      return 'shipmentPallet' + (this.isClickable(pallet) ? ' clickable' : '') + (this.isSelected(pallet) ? ' selected' : '')
    },
    palletPositionClass: function () {
      return 'shipmentPallet clickable ' + (this.isPositionSelected() ? ' selected' : '')
    },
    palletPositionClassSecondRow: function () {
      return 'shipmentPallet clickable ' + (this.isPositionSelectedSecondRow() ? ' selected' : '')
    },
    palletTitle: function (pallet) {
      let palletTitle = '<table class="palletTooltip">'
      if (pallet.number !== pallet.palletNumber) {
        palletTitle += '<tr><td>Number:</td><td>' + pallet.number + '</td></tr>'
      }
      palletTitle += '<tr><td>Supplier:</td><td>' + (pallet.supplier && pallet.supplier.name ? pallet.supplier.name : '') + '</td></tr>'
      palletTitle += '<tr><td>Field:</td><td>' + (pallet.field && pallet.field.address && pallet.field.address ? pallet.field.address.nameAndText : '') + '</td></tr>'
      palletTitle += '<tr><td>Contractor:</td><td>' + (pallet.contractor && pallet.contractor.name ? pallet.contractor.name : '') + '</td></tr>'
      if (pallet.location && pallet.location.nameAndText) {
        palletTitle += '<tr><td>Location:</td><td>' + (pallet.location && pallet.location.nameAndText ? pallet.location.nameAndText : '') + '</td></tr>'
      }
      palletTitle += '<tr><td style="padding-right: 5px;">Loading address:</td><td>' + (pallet.pickupAddress && pallet.pickupAddress.nameAndText ? pallet.pickupAddress.nameAndText : '') + '</td></tr>'
      if (pallet.internalCarrier && pallet.internalCarrier.name) {
        palletTitle += '<tr><td>Internal carrier:</td><td>' + (pallet.internalCarrier && pallet.internalCarrier.name ? pallet.internalCarrier.name : '</td></tr>')
      }
      if (pallet.state === 'DELIVERED' && pallet.deliveryComment && pallet.deliveryComment !== '') {
        palletTitle += '<tr><td>Delivery comment:</td><td><div style="white-space: pre;">' + pallet.deliveryComment + '</div></td></tr>'
      }
      palletTitle += '</table>'
      return palletTitle
    },
    selectPallet: function (pallet) {
      // console.log('Select pallet')
      if (this.isClickable(pallet)) {
        if (this.isSelected(pallet)) {
          this.$emit('change', { pallet: null })
        } else {
          this.$emit('change', { pallet: pallet })
        }
      }
    },
    selectPalletPosition: function () {
      // console.log('Select pallet position ' + this.number)
      this.$emit('change', { palletPosition: this.number })
    },
    selectPalletPositionSecondRow: function () {
      let numberSecondRow = Number(this.number) + 10
      // console.log('Select pallet position second row ' + numberSecondRow)
      this.$emit('change', { palletPosition: numberSecondRow })
    }
  },
  computed: {
    pallet: function () {
      let index = Number(this.number) - 1
      return this.palletPositions[index] ? this.palletPositions[index] : null
    },
    palletSecondRow: function () {
      let index = Number(this.number) + 10 - 1
      return this.palletPositions[index] ? this.palletPositions[index] : null
    },
    hasPallet: function () {
      return this.pallet && this.pallet.id > 0
    },
    hasPalletSecondRow: function () {
      return this.palletSecondRow && this.palletSecondRow.id > 0
    }
  }
}
</script>

<style scoped>
  div.shipmentPallet {
    padding: 5px;
    border: 1px solid #bbbbbb;
    border-radius: 4px;
    min-height: 50px;
  }
  div.clickable {
    cursor: pointer;
  }
  div.selected {
    background-color: rgba(0, 77, 64, 0.1);
    border: 1px solid #606060;
  }
</style>



// WEBPACK FOOTER //
// src/components/ShipmentPallet.vue